import React, { useState, useEffect } from 'react';
import { Video, Shield, Users, FileText, MapPin, Phone, Eye, PlayCircle, CheckCircle, Star,
  MessageSquare,List,Camera,Globe, ArrowRight, Zap, Clock, Lock, Headphones,Smartphone,Monitor } from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const HubLiveLanding = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % 8);
    }, 3000);
    return () => clearInterval(interval);
  }, []);


    const collaborationFeatures = [
    "Geo Location tagging",
    "LIVE chat",
    "100% live call recording",
    "Short videos during LIVE Call",
    "Cross-platform compatibility (mobile, desktop, web)",
    "Picture in Picture mode",
    "Join via link or meeting ID"
  ];


  const features = [
    { icon: Video, title: "Live Video Sessions", desc: "Real-time video calls between agents and clients" },
    { icon: Shield, title: "WebRTC Technology", desc: "Secure peer-to-peer communication" },
    { icon: FileText, title: "Document Support", desc: "Upload and verify multiple document types" },
    { icon: Eye, title: "Auto Verification", desc: "AI-powered automatic identity verification" },
    { icon: Phone, title: "Call Recording", desc: "Automatic and manual call recording options" },
    { icon: Zap, title: "OCR Technology", desc: "Extract data from documents instantly" },
    { icon: MapPin, title: "Location Detection", desc: "Real-time client location tracking" },
    { icon: Lock, title: "Unique ID Generation", desc: "Generate secure unique identifiers" }
  ];
    const keyFeatures = [
    {
      id: 1,
      title: "SMS Notifications",
      description: "Automated SMS notifications are sent to customers to initiate and guide them through the video KYC process.",
      icon: MessageSquare,
      color: "from-gray-400 to-gray-600"
    },
    {
      id: 2,
      title: "Liveness Verification",
      description: "Ensures real-time verification of customer presence during the video KYC process, enhancing security and authenticity.",
      icon: Eye,
      color: "from-green-400 to-green-600"
    },
    {
      id: 3,
      title: "Location Verification",
      description: "Verifies the customer's geographical location to comply with regulatory and operational requirements.",
      icon: MapPin,
      color: "from-blue-400 to-blue-600"
    },
    {
      id: 4,
      title: "KYC List Verification",
      description: "Cross-references customer details with predefined KYC lists for accurate identity validation.",
      icon: List,
      color: "from-orange-400 to-orange-600"
    },
    {
      id: 5,
      title: "OCR Integration",
      description: "Optical Character Recognition (OCR) functionality to extract and auto-fill data from uploaded KYC documents efficiently.",
      icon: Camera,
      color: "from-red-400 to-red-600"
    },
    {
      id: 6,
      title: "Third-Party API Verification",
      description: "Seamless integration with third-party APIs for enhanced verification and validation of customer details.",
      icon: Globe,
      color: "from-green-500 to-green-700"
    },
    // {
    //   id: 7,
    //   title: "Disposition Management",
    //   description: "Centralized management of customer disposition statuses for better tracking and streamlined operations.",
    //   icon: Shield,
    //   color: "from-blue-500 to-blue-700"
    // }
  ];

  const clients = [
    { name: "Havells", logo: "H", color: "bg-red-500" },
    { name: "BlueStar", logo: "B", color: "bg-blue-500" },
    { name: "TechCorp", logo: "T", color: "bg-green-500" },
    { name: "FinanceInc", logo: "F", color: "bg-purple-500" }
  ];

  const stats = [
    { number: "99.9%", label: "Uptime Guarantee" },
    { number: "5sec", label: "Average Connection Time" },
    { number: "256-bit", label: "Encryption Standard" },
    { number: "24/7", label: "Support Available" }
  ];
    const securityFeatures = [
    "End-to-end encryption",
    "Data protection compliance"
  ];

  const brandingFeatures = [
    "Personalized meeting on web",
    "Company logo integration"
  ];

  const videoAudioFeatures = [
    "HD video resolution for a seamless viewing experience",
    "Crystal-clear audio ensures effective communication",
    "High-definition photo capture for enhanced visual documentation"
  ];

  const screenSharingFeatures = [
    // "Intuitive and easy-to-use interface for effortless sharing",
    // "Multiple screen-sharing options tailored to different collaboration needs"
  ];
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      {/* Header */}
      <Header />
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Zap className="w-4 h-4" />
                Next-Gen Video KYC Solution
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Revolutionize
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600"> KYC </span>
                with Live Video
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Seamless agent-to-client video verification with advanced WebRTC technology, 
                automated document processing, and real-time verification capabilities.
              </p>
         
            </div>
            
            <div className={`relative transform transition-all duration-1000 delay-300 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'}`}>
              <div className="relative">
                {/* Main Video Call Interface */}
                <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl p-6 shadow-2xl overflow-hidden">
                  {/* Video Call Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                      <span className="text-white text-sm font-medium">Live KYC Session</span>
                    </div>
                    <div className="flex gap-2">
                      <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    </div>
                  </div>

                  {/* Video Frames */}
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    {/* Agent Video */}
                    <div className="relative bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl p-4 h-32 overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-transparent"></div>
                      <img 
                        src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=face" 
                        alt="KYC Agent" 
                        className="absolute inset-0 w-full h-full object-cover rounded-2xl opacity-80"
                      />
                      <div className="absolute bottom-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded">
                        Agent
                      </div>
                      <div className="absolute top-2 right-2 w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                    </div>

                    {/* Client Video */}
                    <div className="relative bg-gradient-to-br from-green-600 to-emerald-700 rounded-2xl p-4 h-32 overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-r from-green-600/20 to-transparent"></div>
                      <img 
                        src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face" 
                        alt="Client" 
                        className="absolute inset-0 w-full h-full object-cover rounded-2xl opacity-80"
                      />
                      <div className="absolute bottom-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded">
                        Client
                      </div>
                      <div className="absolute top-2 right-2 w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                    </div>
                  </div>

                  {/* Document Verification */}
                  <div className="bg-white rounded-2xl p-4 mb-4">
                    <div className="flex items-center gap-3 mb-3">
                      <FileText className="w-5 h-5 text-blue-600" />
                      <span className="font-semibold text-gray-900">Document Verification</span>
                    </div>
                    <div className="relative bg-gray-100 rounded-lg p-3 mb-3">
                      <img 
                        src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=300&h=200&fit=crop" 
                        alt="ID Document" 
                        className="w-full h-24 object-cover rounded"
                      />
                      <div className="absolute top-2 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded">
                        ✓ Verified
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex items-center gap-2 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        <span className="text-gray-700">OCR Data Extracted</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        <span className="text-gray-700">Face Match: 98.5%</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <MapPin className="w-4 h-4 text-blue-500" />
                        <span className="text-gray-700">Location: Mumbai, India</span>
                      </div>
                    </div>
                  </div>

                  {/* Control Buttons */}
                  <div className="flex justify-center gap-4">
                    <button className="bg-red-500 hover:bg-red-600 text-white p-3 rounded-full transition-colors">
                      <Phone className="w-5 h-5" />
                    </button>
                    <button className="bg-gray-600 hover:bg-gray-700 text-white p-3 rounded-full transition-colors">
                      <Video className="w-5 h-5" />
                    </button>
                    <button className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full transition-colors">
                      <FileText className="w-5 h-5" />
                    </button>
                  </div>
                </div>

                {/* Floating Status Indicators */}
                <div className="absolute -top-6 -right-6 bg-green-400 text-green-900 px-4 py-2 rounded-full text-sm font-medium shadow-lg animate-bounce">
                  ✓ Live
                </div>
                <div className="absolute -bottom-6 -left-6 bg-blue-400 text-blue-900 px-4 py-2 rounded-full text-sm font-medium shadow-lg animate-pulse">
                  🔒 Secure
                </div>
                <div className="absolute top-1/2 -left-4 bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-xs font-medium shadow-lg">
                  WebRTC
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
     {/* Stats Section - Dark */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-white mb-2">{stat.number}</div>
                <div className="text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
         <section className="py-20 bg-gradient-to-br from-indigo-50 to-blue-100">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            See HubLive in Action
          </h2>
          <p className="text-xl text-gray-600">
            Experience the seamless KYC process with our interactive demo
          </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
          <div className="col">
            <img src="./videotech1.png" alt="Video Technology" className="w-full h-[850px] w-[520px]  object-cover rounded-lg" />
          </div>
          <div className="col">
            <img src="./videoTechnology.png" alt="Video Technology" className="w-full h-[850px] w-[520px] object-cover rounded-lg" />
          </div>
            </div> 
             {/* Demo Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Video className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">HD Video Quality</h3>
              <p className="text-gray-600">Crystal clear video calls with adaptive bitrate streaming</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Zap className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Instant Processing</h3>
              <p className="text-gray-600">Real-time document verification and OCR processing</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Bank-grade Security</h3>
              <p className="text-gray-600">End-to-end encryption with compliance standards</p>
            </div>
          </div>
        </div>
         <div className="max-w-7xl mx-auto px-6 mt-16">
            <img src="./dashboard.png" alt="Video Technology" className="w-full h-[850px]   object-cover rounded-lg" />
          </div>
      </section>
 
     {/* Key Features Section - Dark */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Key Features & Functionality</h2>
            <p className="text-xl text-gray-400">Comprehensive tools designed for secure and efficient customer verification</p>
          </div>
          
          <div className="relative">
            {/* Central Hub */}
            <div className="flex justify-center mb-12">
              <div className="relative">
                <div className="w-32 h-32 bg-gradient-to-br from-purple-500 to-blue-600 rounded-full flex items-center justify-center shadow-2xl animate-pulse">
                  <Video className="h-16 w-16 text-white" />
                </div>
                <div className="absolute -inset-4 bg-gradient-to-r from-purple-400 to-blue-400 rounded-full opacity-20 animate-ping"></div>
              </div>
            </div>

            {/* Feature Circles */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {keyFeatures.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={feature.id}
                    className={`group relative p-6 bg-gray-800 rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer border-2 border-transparent hover:border-blue-500 ${
                      activeFeature === index ? 'ring-2 ring-blue-500 scale-105' : ''
                    }`}
                    onMouseEnter={() => setActiveFeature(index)}
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-full flex items-center justify-center mb-4 group-hover:animate-bounce`}>
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                    <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                      <CheckCircle className="h-6 w-6 text-green-500" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
    <section>
      {/* Advanced Features Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">Advanced Features</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
            {/* Real-Time Collaboration Card */}
            <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center mr-4">
                  <Users className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Real-Time Collaboration</h3>
              </div>
              <ul className="space-y-3">
                {collaborationFeatures.slice(0, 4).map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <Zap className="h-4 w-4 text-orange-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
              {/* <div className="mt-4 pt-4 border-t border-orange-200">
                <p className="text-xs text-gray-600">+{collaborationFeatures.length - 4} more features</p>
              </div> */}
            </div>

            {/* Security Card */}
            <div className="bg-gradient-to-br from-green-50 to-teal-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center mr-4">
                  <Lock className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Secure Encryption</h3>
              </div>
              <ul className="space-y-3 mb-6">
                {securityFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <Shield className="h-4 w-4 text-teal-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="space-y-3">
                <div className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-teal-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-gray-700 text-sm leading-relaxed">SSL/TLS protocol support</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-teal-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-gray-700 text-sm leading-relaxed">Secure data transmission</span>
                </div>
              </div>
            </div>

            {/* Custom Branding Card */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-4">
                  <Smartphone className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Custom Branding</h3>
              </div>
              <ul className="space-y-3 mb-6">
                {brandingFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <CheckCircle className="h-4 w-4 text-pink-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="space-y-3">
                <div className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-pink-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-gray-700 text-sm leading-relaxed">Custom color themes</span>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-pink-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-gray-700 text-sm leading-relaxed">Branded email templates</span>
                </div>
              </div>
            </div>

            {/* Video & Audio Card */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center mr-4">
                  <Video className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Video & Audio Quality</h3>
              </div>
              <ul className="space-y-3 mb-6">
                {videoAudioFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <Camera className="h-4 w-4 text-indigo-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="space-y-3">
                {screenSharingFeatures.slice(0, 1).map((feature, index) => (
                  <div key={index} className="flex items-start">
                    <Monitor className="h-4 w-4 text-indigo-500 mr-3 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>

      {/* CTA Section */}
    {/* CTA Section - Dark */}
      {/* <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Ready to Transform Your KYC Process?
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Join thousands of businesses already using HubLive for seamless video verification
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 justify-center">
              <ArrowRight className="w-5 h-5" />
              Start Free Trial
            </button>
            <button className="border border-gray-600 text-gray-300 px-8 py-3 rounded-lg hover:bg-gray-800 transition-colors">
              Schedule Demo
            </button>
          </div>
        </div>
      </section> */}

      {/* Footer */}
  
      <Footer />
    </div>
  );
};

export default HubLiveLanding;

